/* AD-05 · FRAUD & DEVICE RISK
   ADM-13/36/37: flags, evidence, clear/escalate; hash/rotation/retention
   policy; kiosk exception rules; risk signals 90 d (locked #17). · Bible §43 */
import { ListRow, Note } from '@/ui'
import { useAdmin } from './AdminShell'
import Mark from './Mark'

export default function AD05Fraud() {
  const rows = useAdmin().fraud
  return (
    <section data-frame="AD-05" style={{ display: 'grid', gap: 14 }}>
      <h2 className="t-section">File fraude &amp; exceptions appareil</h2>
      <div>
        {rows.map(r => (
          <ListRow key={r.title} title={r.title} meta={r.meta}
            end={<Mark cell={r.status} />} />
        ))}
      </div>
      <Note tone="candour">
        Décisions : neutraliser / challenger / autoriser / bloquer — avec expiration,
        approbateur, correction et audit. Jamais de culpabilité automatique ; l’empreinte
        durable n’est jamais une identité client.
      </Note>
    </section>
  )
}
